import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { SalesforceFooter } from './components/SalesforceFooter';
import { SalesforceRegistrationForm } from './components/SalesforceRegistrationForm';
import type { SalesforceRegisterFormValues } from './SalesforceRegisterFormSchema';
import { SalesforceRegisterFormSchema } from './SalesforceRegisterFormSchema';

export const RegisterToSalesforceComponents: FormDrawerProps<ZodSchema<SalesforceRegisterFormValues>> = {
  zodSchema: SalesforceRegisterFormSchema,
  ContentComponent: SalesforceRegistrationForm,
  Footer: SalesforceFooter,
};
